var exports = {
  "kL": "container__4QsY6t",
  "lp": "kbdWrapper__gBC8b4",
  "Z2": "proTipLabel__YcSvlZ",
  "m_": "proTipIcon__jklbOL",
  "IS": "proTipText__GNqUcg",
};

module.exports = exports;
